export const marketPairs = [
  {
    symbol: 'EUR/USD',
    name: 'ยูโร / ดอลลาร์สหรัฐ',
    price: '1.0842',
    spread: '0.8',
    pip: '+12.4 pips',
    trend: 'ขึ้น',
    trendUp: true,
    change: '+0.34%',
  },
  {
    symbol: 'GBP/USD',
    name: 'ปอนด์ / ดอลลาร์สหรัฐ',
    price: '1.2716',
    spread: '1.1',
    pip: '+7.2 pips',
    trend: 'ขึ้น',
    trendUp: true,
    change: '+0.21%',
  },
  {
    symbol: 'USD/JPY',
    name: 'ดอลลาร์สหรัฐ / เยน',
    price: '149.83',
    spread: '0.9',
    pip: '-5.6 pips',
    trend: 'ลง',
    trendUp: false,
    change: '-0.18%',
  },
  {
    symbol: 'XAU/USD',
    name: 'ทองคำ / ดอลลาร์สหรัฐ',
    price: '2,382.40',
    spread: '2.4',
    pip: '+18.9 pips',
    trend: 'ขึ้น',
    trendUp: true,
    change: '+0.62%',
  },
];

export const eurUsdSeries = [42, 45, 43, 48, 52, 50, 55, 58, 54, 60, 63, 61, 66, 70, 68, 74];

/**
 * Three fixed teaching cases used by the homepage sample quote card.
 * Each case is a hand written price series, so the lesson never changes and
 * never depends on a live feed.
 */
export const trendScenarios = [
  {
    id: 'uptrend',
    tab: 'ขาขึ้น',
    symbol: 'EUR/USD',
    name: 'ยูโร / ดอลลาร์สหรัฐ',
    price: '1.0842',
    change: '+2.96%',
    spread: '0.8',
    pip: '+30.2 pips',
    trend: 'ขาขึ้น',
    trendUp: true,
    tone: 'up',
    series: [
      1.053, 1.0556, 1.0541, 1.0598, 1.0625, 1.0612, 1.0668, 1.0704,
      1.0691, 1.0736, 1.0772, 1.0758, 1.0801, 1.0824, 1.081, 1.0842,
    ],
    points: [
      'จุดสูงใหม่สูงขึ้นเรื่อย ๆ (Higher High) และจุดต่ำใหม่ก็ยกขึ้น (Higher Low)',
      'การย่อแต่ละครั้งไม่หลุดจุดต่ำเดิม แล้วไปต่อได้ ทำให้เห็นแนวโน้มชัด',
      'มือใหม่: รอย่อใกล้แนวรับแล้วค่อยตาม ไม่ไล่ซื้อที่ยอด',
    ],
  },
  {
    id: 'range',
    tab: 'ไซด์เวย์',
    symbol: 'USD/JPY',
    name: 'ดอลลาร์สหรัฐ / เยน',
    price: '149.83',
    change: '+0.27%',
    spread: '0.9',
    pip: '±0.9 เยน',
    trend: 'ไซด์เวย์',
    trendUp: true,
    tone: 'flat',
    series: [
      149.42, 150.16, 149.68, 150.05, 149.51, 149.94, 150.22, 149.73,
      149.35, 149.88, 150.11, 149.62, 149.97, 149.44, 149.79, 149.83,
    ],
    points: [
      'ราคาแกว่งในกรอบบน–ล่าง ไม่ทำจุดสูงหรือจุดต่ำใหม่ให้เห็นชัด',
      'ขอบบนมักถูกขาย ขอบล่างมักถูกซื้อ ตราบใดที่ยังไม่หลุดกรอบ',
      'มือใหม่: เล่นในกรอบแคบ ๆ พอ ตั้ง Stop Loss เลยขอบกรอบเสมอ',
    ],
  },
  {
    id: 'downtrend',
    tab: 'ขาลง',
    symbol: 'GBP/USD',
    name: 'ปอนด์ / ดอลลาร์สหรัฐ',
    price: '1.2716',
    change: '-2.09%',
    spread: '1.1',
    pip: '-27.2 pips',
    trend: 'ขาลง',
    trendUp: false,
    tone: 'down',
    series: [
      1.2988, 1.2962, 1.2975, 1.2914, 1.2876, 1.289, 1.2831, 1.2804,
      1.2818, 1.2765, 1.2732, 1.2746, 1.2701, 1.2688, 1.27, 1.2716,
    ],
    points: [
      'จุดต่ำใหม่ต่ำลงเรื่อย ๆ (Lower Low) และจุดสูงใหม่ก็กดลง (Lower High)',
      'ทุกครั้งที่เด้งขึ้นมักติดแนวต้านเดิม ราคาไม่สามารถปิดเหนือกรอบได้',
      'มือใหม่: ไม่รับมีดที่กำลังตก รอให้เกิดสัญญาณกลับตัวก่อนเสมอ',
    ],
  },
];

export const candleData = [
  { high: 78, low: 52, bodyTop: 74, bodyBottom: 58, up: true },
  { high: 80, low: 60, bodyTop: 78, bodyBottom: 64, up: true },
  { high: 76, low: 54, bodyTop: 72, bodyBottom: 56, up: false },
  { high: 70, low: 46, bodyTop: 66, bodyBottom: 52, up: false },
  { high: 66, low: 40, bodyTop: 62, bodyBottom: 44, up: true },
  { high: 72, low: 48, bodyTop: 68, bodyBottom: 52, up: true },
  { high: 84, low: 62, bodyTop: 80, bodyBottom: 66, up: true },
  { high: 88, low: 70, bodyTop: 86, bodyBottom: 72, up: true },
  { high: 82, low: 58, bodyTop: 78, bodyBottom: 60, up: false },
  { high: 74, low: 50, bodyTop: 70, bodyBottom: 56, up: false },
  { high: 78, low: 52, bodyTop: 74, bodyBottom: 56, up: true },
  { high: 86, low: 64, bodyTop: 84, bodyBottom: 68, up: true },
];

export const candleDataMt5 = [
  { high: 86, low: 70, bodyTop: 80, bodyBottom: 72, up: true },
  { high: 84, low: 66, bodyTop: 80, bodyBottom: 70, up: false },
  { high: 74, low: 56, bodyTop: 70, bodyBottom: 60, up: false },
  { high: 66, low: 48, bodyTop: 60, bodyBottom: 52, up: false },
  { high: 58, low: 40, bodyTop: 52, bodyBottom: 44, up: false },
  { high: 50, low: 30, bodyTop: 44, bodyBottom: 36, up: false },
  { high: 42, low: 24, bodyTop: 36, bodyBottom: 30, up: false },
  { high: 38, low: 20, bodyTop: 32, bodyBottom: 26, up: false },
  { high: 38, low: 24, bodyTop: 34, bodyBottom: 26, up: true },
  { high: 46, low: 32, bodyTop: 42, bodyBottom: 34, up: true },
  { high: 54, low: 40, bodyTop: 50, bodyBottom: 42, up: true },
  { high: 60, low: 48, bodyTop: 56, bodyBottom: 50, up: true },
  { high: 66, low: 54, bodyTop: 62, bodyBottom: 56, up: true },
  { high: 66, low: 52, bodyTop: 62, bodyBottom: 56, up: false },
];